import { createSlice } from '@reduxjs/toolkit';


export const gameplaySlice = createSlice({
   name: 'gameplay',
   initialState: {},
   reducers: {
      setGameplayData: (state, { payload }) => {
         state.data = payload;
      }
   },
});

export const {
   setGameplayData,
} = gameplaySlice.actions;

export default gameplaySlice.reducer;
